export const GroupBy = (array, key) => {
    return array
      .reduce((hash, obj) => {
        if(obj[key] === undefined) return hash; 
        return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
      }, {})
}

export const GetCountOfObjectKeys = (obj) => Object.keys(obj).length; 

export const IsArrayNullOrEmpty = (array: any[]) => !array || array.length === 0;

export const Buffer2Base64 = (buffer: ArrayBuffer) => {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
}
